import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import '../Organic Fruits Tenders/OrganicFruitsTenders.css';

const OrganicFruitsTenders = () => {
  return (
    <>
    <section id='Organic-Tenders'>
      <Container>
        <Row>
          <Col lg={5}  xs={8}>
          <img src="./imeges/Desktop2/Rectangle 3038.svg" alt="" className='w-100'/>
          </Col>
          <Col lg={2} xs={4}>
            <ul style={{display: 'grid', rowGap:'24px'}}>
             <li><img src="./imeges/Desktop2/lemon.svg" alt=""  className='w-100' /></li>
             <li><img src="./imeges/Desktop2/jasberry.svg" alt=""  className='w-100' /></li>
             <li><img src="./imeges/Desktop2/tomoto.svg" alt=""  className='w-100' /></li>
            </ul>
          </Col>
          <Col lg={5}>
            <h2>Organic Fruits Tenders</h2>
            <div className='Organic-Tenders'>
            <ul className='Organic-Tenders_ul'>
              <li className='first-li'>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
                <i class="fa-solid fa-star"></i>
              </li>
              <li>10 Reviews</li>
              <li><p className='Organic-Tenders_ul-text'><strong>Brand:</strong> Organic</p></li>
            </ul>
            <p style={{ fontFamily: 'Inter', fontStyle: 'normal', fontWeight: 400, fontSize: 16,color: '#676767' , padding: 0,}}>
            Your text hereLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
            </p>
            <div className='Organic-Tenders-btn-gropue' style={{ display: 'flex' }}>
              <Button variant="outline-secondary" style={{ flex: '1 1 50%', marginRight: '20px' }}>
                <i className="fa-solid fa-minus"></i>1kg<i className="fa-solid fa-plus"></i>
              </Button>
              <Button variant="warning" style={{ flex: '1 1 50%', marginLeft: '20px' }}>
                <i className="fa-solid fa-cart-shopping"></i>Add to cart
              </Button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', padding: '20px 0' }}>
              <div style={{ gridColumn: '1 / span 2' }}>
                <Button variant="success" style={{ width: '100%' }}>
                  Buy Now
                </Button>
              </div>
            </div>
                <div className='Organic-Tenders-btn-gropues'style={{ display: 'flex' }}>
                  <Button variant="outline-secondary"style={{ flex: '1 1 50%', marginRight: '20px' }}>
                    <i class="fa-regular fa-heart"></i>Add to wishlist
                    </Button>
                  <Button variant="outline-secondary" style={{ flex: '1 1 50%', marginLeft: '20px' }}>
                    <i class="fa-solid fa-arrow-right-arrow-left"></i>Add to Compare
                    </Button>
                </div>
                <ul className='Organic-Tenders-icon'>
                  <li><p> <strong>Category:</strong> Organic</p></li>
                  <li><p> <strong>Tags:</strong> Food,organic,vegetables,fresh</p></li>
                  <li className='Organic-Tenders-socil-midea'>
                    <p>  <strong>Share: </strong></p>
                    <div class="icon"><i class="fa-brands fa-square-facebook"></i></div>
                    <div class="icon"><i class="fa-brands fa-square-twitter"></i></div>
                    <div class="icon"><i class="fa-brands fa-pinterest"></i></div>
                    <div class="icon"><i class="fa-brands fa-square-dribbble"></i></div>
                  </li>
                </ul>
                <div className='Organic-Tenders-Underline'></div>
                <h4 className='Organic-Tenders-titel'> Sold by : WPDISDB</h4>
                <ul className='Organic-Tenders-btn-gropue'>
                  <li>100% Natural</li>
                  <li>1Increases resistance</li>
                  <li>1No growth hormones are used</li>
                  <li>No artificial Chemicals</li>
                </ul>
                <div className='Organic-Tenders-Underline'></div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    </>
  );
};

export default OrganicFruitsTenders;